import { Box, Typography } from "@mui/material";
import { FC } from "react";
import { Site } from "types/site";

export const SiteItem: FC<{ site: Site }> = ({ site }) => {
  return (
    <Box mb={1} bgcolor="rgba(0,0,0,0.04)" px={2} py={1} borderRadius={1}>
      <Typography variant="body1">{site.name}</Typography>
      <Typography variant="body2">{site.address.address_line_1}</Typography>
      <Typography variant="body2">{site.address.address_line_2}</Typography>
      <Typography variant="body2">
        {site.address.city} - {site.address.state}
      </Typography>
      <Typography variant="body2">
        {site.address.country} - {site.address.zip_code}
      </Typography>
    </Box>
  );
};
